/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ space: NonNullable<unknown> }} Chat_Onedata_Delete_Space_SummaryInputs */



/**
* | output |
* | --- |
* | "Permanently delete dataset space {space}" |
*
* @param {Chat_Onedata_Delete_Space_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_onedata_delete_space_summary = /** @type {((inputs: Chat_Onedata_Delete_Space_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Onedata_Delete_Space_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Datensatz-Space ${i?.space} dauerhaft löschen`)
	return /** @type {LocalizedString} */ (`Permanently delete dataset space ${i?.space}`)
});